import styled, { keyframes } from 'styled-components';
import { Icon } from '../Icon';

const rotate = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
`;

export const RotatingIcon = styled(Icon)`
  animation: ${rotate} 1s linear infinite;
`;
